module.exports = "https://web-assets.ifttt.com/packs/media/products/device-ios-0cfc1941.png";